import { render, staticRenderFns } from "./StandCard.vue?vue&type=template&id=5b5379fa&"
import script from "./StandCard.vue?vue&type=script&lang=js&"
export * from "./StandCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports